var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack1101({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.5px;}.b{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 14.57 15 7.74 1 7.74 8 14.57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.22,5.91V1.62H7.7a3.72,3.72,0,0,1,.77.06A1.54,1.54,0,0,1,9.1,2a1.85,1.85,0,0,1,.51.74,3,3,0,0,1,.17,1,2.9,2.9,0,0,1-.12.87,2.1,2.1,0,0,1-.29.62A1.44,1.44,0,0,1,9,5.62a1.54,1.54,0,0,1-.52.22,2.87,2.87,0,0,1-.69.07Zm.57-.51h.92a2,2,0,0,0,.67-.08.83.83,0,0,0,.38-.22,1.29,1.29,0,0,0,.32-.54,2.88,2.88,0,0,0,.11-.83A2,2,0,0,0,9,2.7a1.09,1.09,0,0,0-.54-.49,2.16,2.16,0,0,0-.73-.09H6.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack1101);
export default __webpack_public_path__ + "static/media/Symbolpack_1_101.93edcba0143b89f83dd28f922de884cd.svg";
export { ForwardRef as ReactComponent };